import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 28, className = "", ...rest }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.9, delay, ease: EASE }}
    className={className}
    {...rest}
  >
    {children}
  </motion.div>
);

export const Chapter = ({ label }) => (
  <Reveal className="flex items-center gap-3 mb-7" y={12}>
    <span className="h-px w-8 bg-signal-cyan/60" />
    <span className="text-xs font-semibold uppercase tracking-[0.22em] text-steel">
      {label}
    </span>
  </Reveal>
);

export const SectionHead = ({ title, sub, className = "" }) => (
  <div className={className}>
    <Reveal>
      <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight leading-[1.06] text-mist whitespace-pre-line">
        {title}
      </h2>
    </Reveal>
    {sub && (
      <Reveal delay={0.12}>
        <p className="mt-6 text-lg leading-relaxed text-steel max-w-xl">
          {sub}
        </p>
      </Reveal>
    )}
  </div>
);
